const financeOrganizationConfig = [{
  desc: '查询组织映射',
  options: {
    url: '/financeOrganizationConfig/queryOrgMapping',
    method: 'post'
  }
}, {
  desc: '组织映射关系操作：禁用、启用或重置',
  options: {
    url: '/financeOrganizationConfig/operateOrgMapping',
    method: 'post'
  }
}, {
  desc: '新增或修改组织映射',
  options: {
    url: '/financeOrganizationConfig/saveOrUpdateOrgMapping',
    method: 'post'
  }
}, {
  desc: '组织费率操作：禁用、启用',
  options: {
    url: '/financeOrganizationConfig/operateOrgTaxRate',
    method: 'post'
  }
}, {
  desc: '查询组织费率',
  options: {
    url: '/financeOrganizationConfig/queryOrgTaxRate',
    method: 'post'
  }
}, {
  desc: '新增或修改组织费率',
  options: {
    url: '/financeOrganizationConfig/saveOrUpdateOrgTaxRate',
    method: 'post'
  }
}, {
  desc: '查询金蝶组织列表',
  options: {
    url: '/financeOrganizationConfig/queryKingDeeOrgList',
    method: 'post'
  }
}, {
  desc: '营销费用比例列表',
  options: {
    url: '/financeOrganizationConfig/queryOrgCostRate',
    method: 'post'
  }
}, {
  desc: '启用/禁用营销费用比例',
  options: {
    url: '/financeOrganizationConfig/operateOrgCostRate',
    method: 'post'
  }
}, {
  desc: '编辑营销费用比例',
  options: {
    url: '/financeOrganizationConfig/saveOrUpdateOrgCostRate',
    method: 'post'
  }
}]
export default financeOrganizationConfig



// WEBPACK FOOTER //
// ./src/api/financeOrganizationConfig.js